import { render, staticRenderFns } from "./VoucherTypes.vue?vue&type=template&id=08ec4c32&scoped=true&"
import script from "./VoucherTypes.vue?vue&type=script&lang=js&"
export * from "./VoucherTypes.vue?vue&type=script&lang=js&"
import style0 from "./VoucherTypes.vue?vue&type=style&index=0&id=08ec4c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ec4c32",
  null
  
)

component.options.__file = "VoucherTypes.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VIcon})
